import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component LayerBackIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <LayerBackIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <LayerBackIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const LayerBackIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="LayerBackIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M22 12a.83.83 0 0 0-.41-.717l-1.959-1.158 1.96-1.157a.834.834 0 0 0 0-1.435l-9.167-5.417a.83.83 0 0 0-.848 0L2.409 7.533a.833.833 0 0 0 0 1.435l1.96 1.157-1.96 1.158a.833.833 0 0 0 0 1.435l1.96 1.157-1.96 1.158a.833.833 0 0 0 0 1.435l9.167 5.416a.83.83 0 0 0 .848 0l9.167-5.416a.834.834 0 0 0 0-1.435l-1.96-1.158 1.96-1.157A.83.83 0 0 0 22 12M12 3.801l7.528 4.45L12 12.698 4.471 8.25zm-.424 10.583a.83.83 0 0 0 .848 0l5.57-3.29 1.535.907L12 16.449 4.471 12l1.536-.907z" />
      <path d="M19.528 15.75 12 20.2l-7.529-4.45 1.536-.907 5.57 3.29a.83.83 0 0 0 .848 0l5.57-3.29z" />
    </svg>
  )
);
LayerBackIcon.displayName = "LayerBackIcon";
export default LayerBackIcon;
